export const layout = [{ text: 'Grid Layout', value: 'gridLayout' }, { text: 'Table Layout', value: 'tableLayout' }]

export const sortBy = [
  { text: 'ID', value: 'id' },
  { text: 'Name', value: 'name' },
  { text: 'Status', value: 'status' },
  { text: 'Size (qm)', value: 'sizeQm' },
  { text: 'Quality', value: 'quality' },
  { text: 'Dessin', value: 'dessin' },
  { text: 'Producer', value: 'producer' },
  { text: 'Customer', value: 'customer' },
  { text: 'Primary Picture Source', value: 'pictureSource' },
  { text: 'Order Date', value: 'dateOrder' },
  { text: 'Receipt Date', value: 'dateReceipt' },
  { text: 'Scan Date', value: 'dateScanned' },
]

export const sortOrder = [{ text: 'Ascending', value: 'ascending' }, { text: 'Descending', value: 'descending' }]
